import React, { useState } from "react";
import { Image } from "antd-mobile";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { DownFill } from "antd-mobile-icons";
import useCustomTranslation from "@/hooks/useTranslation";
interface DropTimeProps {
	index: number;
	handleOptionClick: (index: number) => void;
}

const DropTime: React.FC<DropTimeProps> = ({ index, handleOptionClick }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const options = [
		{
			value: 0,
			text: t("Today"),
		},
		{
			value: 1,
			text: t("Yesterday"),
		},
		{
			value: 7,
			text: "7" + t("WithinDays"),
		},
		{
			value: 30,
			text: "30" + t("WithinDays"),
		},
	]; // 下拉框选项

	const toggleDropdown = () => {
		setIsOpen(!isOpen);
	};
	const getTextByValue = (value: number) => {
		const option = options.find((option) => option.value === value);
		return option ? option.text : "";
	};

	return (
		<div className={classes.dropdown}>
			<div className={classes.selected} onClick={toggleDropdown}>
				<Image
					src={require("@/assets/images/icons/day.png")}
					className="icon"
				/>
				<span>{getTextByValue(index)}</span>
				<DownFill
					fontSize={10}
					color="#5E71B7"
					className={isOpen ? classes.rotated : ""}
				/>
			</div>
			{isOpen && (
				<div className={classes.options}>
					{options.map((option, idx) => (
						<div
							key={option.value}
							className={`${classes.option} ${
								option.value === index ? "active" : ""
							}`}
							onClick={() => {
								handleOptionClick(option.value);
								setIsOpen(false);
							}}
						>
							{option.text}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default DropTime;

const useStyles = createUseStyles({
	dropdown: {
		position: "relative",
		cursor: "pointer",
		minWidth: pxToRem(96),
	},
	rotated: {
		transform: "rotate(180deg)",
		transition: "transform 0.3s ease",
	},
	selected: {
		display: "flex",
		alignItems: "center",
		padding: {
			left: pxToRem(7),
			right: pxToRem(7),
			top: pxToRem(6),
			bottom: pxToRem(6),
		},
		borderRadius: pxToRem(40),
		backgroundColor: "#181A20",
		"& .icon": {
			width: pxToRem(17),
			height: pxToRem(17),
		},
		"& span": {
			flex: 1,
			overflow: "hidden",
			color: "#FFFFFF",
			fontSize: pxToRem(14),
			fontWeight: 500,
			textAlign: "center",
			fontFamily: "Noto Sans SC",
			padding: {
				left: pxToRem(6),
				right: pxToRem(6),
			},
		},
	},
	options: {
		position: "absolute",
		top: "110%",
		left: 0,
		right: 0,
		zIndex: 1000,
		padding: {
			top: pxToRem(10),
			bottom: pxToRem(10),
		},
		borderRadius: pxToRem(10),
		border: "1px solid #2F3A62",
		backgroundColor: "#181A20",
	},
	option: {
		color: "#FFFFFF",
		fontSize: pxToRem(12),
		fontWeight: 400,
		lineHeight: pxToRem(30),
		textAlign: "center",
		"&:active": {
			opacity: 0.8,
		},
		"&.active": {
			backgroundColor: "#101216",
		},
	},
});
